export interface ThemeResponsiveProperty<T> {
  phone?: T;
  tablet?: T;
  desktop?: T;
}

export interface CustomMediaResponsiveProperty<
  T,
> extends ThemeResponsiveProperty<T> {
  [key: number]: T;
  [key: string]: T | undefined;
}

export type ResponsiveProperty<T> = T | CustomMediaResponsiveProperty<T>;

export const isResponsiveObject = <T>(
  value: ResponsiveProperty<T> | undefined
): value is CustomMediaResponsiveProperty<T> =>
  typeof value === 'object' && value !== null && !Array.isArray(value);

export const resolveResponsive = <T>(
  value: ResponsiveProperty<T> | undefined
): T | undefined => {
  if (isResponsiveObject(value)) {
    return value.desktop ?? value.tablet ?? value.phone;
  }
  return value;
};

export const lengthValue = (
  value: number | string | undefined
): string | undefined => (typeof value === 'number' ? `${value}px` : value);
